import get from "lodash.get";
import numeral from "numeral";

export const currencyFormatter = num => {
  if (num >= 1000000) {
    return numeral(num).format("$0.00a");
  } else {
    return numeral(num).format("$0,0");
  }
};

// I can't think of a better name for this
export const round = num => numeral(num).format("0.[00]");
export const formatInteractionStatsByType = resp => {
  const interactionStatsByType = get(resp, "stats.id", []).reduce((accum, obj) => {
    accum[obj.group_by_field_value] = obj.stats.count || 0;
    return accum;
  }, {});
  return { interactionStatsByType, total: resp.total };
};
